export default "__VITE_ASSET__971278d4__"